// throws errors that aren't otherwise handled during rendering process
export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.hook('vue:error', (err) => {
    throw createError(err)
  })
})
